import { DatatableContextProvider } from "@/components/tables/contexts/DatatableContextProvider";
import ColumnPickerProvider from "@/components/column/ColumnPickerProvider";
import DbtCoreSyncHistoryContent from "./DbtCoreSyncHistoryContent";
import { SyncHistory } from "@/types/integration";

interface DbtCoreSyncHistoryProps {
  syncHistory: SyncHistory[];
}

/**
 * Wrapper component that provides required context for DataTable pagination.
 * The inner component uses useTablePagination which requires DatatableContextProvider.
 */
export const DbtCoreSyncHistory = ({ syncHistory }: DbtCoreSyncHistoryProps): JSX.Element => {
  return (
    <ColumnPickerProvider>
      <DatatableContextProvider>
        <DbtCoreSyncHistoryContent syncHistory={syncHistory} />
      </DatatableContextProvider>
    </ColumnPickerProvider>
  );
};
